import { AssetType, Company, CompanyType, Developer, Employee, ServiceProviderDataFragment, UserRole, UserType} from "@/graphql/__generated__/graphql-operations";
import { typeNavLink } from "@/types";
import { BanknotesIcon, BuildingOfficeIcon, ChartBarIcon, CloudArrowUpIcon, CommandLineIcon, ComputerDesktopIcon, InboxStackIcon, LinkIcon, Square3Stack3DIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

type Props = {
  user: Employee | Developer,
  company: Company | null,
  path: { pathname: string },
  sideMenuOpen: boolean,
  spdetails: ServiceProviderDataFragment | null,
  setSideMenuOpen: Dispatch<SetStateAction<boolean>>
}

function Navlinks(props: Props) {
  // props
  const { user, path, sideMenuOpen, company, spdetails } = props;

  // Hooks
  const { t } = useTranslation(["components"]);

  const navLinks: typeNavLink[] = [
    {name: t("header.navlinks.dashboard"), link: "/user/dashboard", visibility: [UserType.Employee, UserType.Financier], icon: <ComputerDesktopIcon className="mf-icon-base" />},
    {name: t("header.navlinks.makeinvestment"), link: "/user/investment", visibility:[UserType.Financier], icon: <BanknotesIcon className="mf-icon-base" />},
    {name: t("header.navlinks.portfolio"), link: "/user/portfolio", visibility:[UserType.Financier], icon: <ChartBarIcon className="mf-icon-base" />},
    {name: t("header.navlinks.assetsoverview"), link: "/user/assetoverview", visibility: [UserType.Employee, CompanyType.Serviceprovider], icon: <Square3Stack3DIcon className="mf-icon-base" />},
    {name: t("header.navlinks.adminpage"), link: "/admin/dashboard", visibility: [UserType.Developer], icon: <CommandLineIcon className="mf-icon-base" />},
    {name: t("header.navlinks.creditlimitrequests"), link: "/admin/creditlimitrequests", visibility: [UserType.Developer], icon: <InboxStackIcon className="mf-icon-base" />},
    // {name: t("header.navlinks.manageusers"), link: user.__typename === "Developer"? "/admin/manageusers": "/user/manageusers", visibility: [UserType.Developer, UserRole.Superuser], icon: <UserGroupIcon className="mf-icon-base" />},
    {name: t("header.navlinks.customers"), link: "/user/customersoverview", visibility: [CompanyType.Serviceprovider, AssetType.Receivable], icon: <UserCircleIcon className="mf-icon-base" />},
    {name: t("header.navlinks.createcompany"), link: "/admin/createcompany", visibility: [UserType.Developer], icon: <BuildingOfficeIcon className="mf-icon-base" />},
    {name: t("header.navlinks.deploy"), link: "/admin/deploy", visibility: [UserType.Developer], icon: <CloudArrowUpIcon className="mf-icon-base" />},
    {name: t("header.navlinks.tokentransactions"), link: user.role === UserRole.Admin ? "/admin/transactions": "/user/transactions", visibility: [UserType.Developer, UserRole.Superuser], icon: <LinkIcon className="mf-icon-base" />},
  ];

  return (
    <div
      className={`${sideMenuOpen? "top-[90px] left-0 right-0 opacity-100 ": "top-[-500px] opacity-0"}
        z-[100] md:text-gray-600 dark:text-white bg-white md:bg-transparent dark:bg-mfdarklight flex md:flex-row flex-col absolute md:static md:flex-1 shadow-lg
        dark:shadow-gray-950 md:shadow-none gap-y-2 md:gap-y-0 px-2 md:px-0 rounded-b-lg md:rounded-b-none md:gap-x-2 pb-6 md:pb-0 md:opacity-100
      `}
    >
      {
        navLinks.map(({name, link, visibility, icon}) => (
          (
            visibility.includes(user.role) ||
            visibility.includes(user.usertype) ||
              (visibility.includes(company?.companytype as string) && visibility.includes(spdetails?.assetfinancingpool.assetType as string))
          ) &&
            <NavLink
              key={link + name}
              to={link}
              className={({isActive}) => `
                ${isActive ? "text-mforange dark:text-mforange" : ""}
                flex items-center p-4 md:p-2 rounded-md relative text-gray-800 dark:text-gray-100 transition-colors duration-200 ease-in-out hover:text-mforange
              `}
            >
              <div className="md:hidden lg:flex">
                {icon}
              </div>
              <div
                className={`group-hover:flex flex ${path.pathname === link ? "flex":""} font-semibold`}
              >
                {name}
              </div>
            </NavLink>
        ))
      }
    </div>
  );
}

export default Navlinks;
